import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1 1 auto;
  overflow-x: hidden;
`;
